<div class="d-flex flex-column gap-3">
    @if (!originalImageUrl() && currentImageUrl()) {
        <img class="big-preview" [src]="currentImageUrl()"/>
    }
    @if (originalImageUrl()) {
        <div class="px-4">
            <image-cropper
                [imageURL]="originalImageUrl()"
                [maintainAspectRatio]="true"
                [aspectRatio]="1 / 1"
                [format]="'jpeg'"
                [imageQuality]="80"
                [resizeToHeight]="1320"
                [resizeToWidth]="1320"
                [roundCropper]="true"
                [onlyScaleDown]="true"
                (imageCropped)="imageCropped($event)"/>
        </div>
    }

    <app-generic-button
        (click)="takeProfilePicture()"
        description="Add or replace profile picture"
        [alwaysShowText]="true"
        [buttonText]="originalImageUrl() || currentImageUrl() ? 'Replace profile picture' : 'Add profile picture'"/>
    <app-generic-button
        (click)="clearProfilePicture()"
        description="Clear profile picture"
        [alwaysShowText]="true"
        [disabled]="!originalImageUrl() && !currentImageUrl()"
        [buttonClass]="'btn-danger btn-danger-shadow'"
        [buttonText]="'Clear profile picture'"/>
</div>
